'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _equals = require('ramda/src/equals');

var _equals2 = _interopRequireDefault(_equals);

var _most = require('most');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var waitUntil = function waitUntil(f) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

  return (0, _most.unfold)(function (done) {
    return new Promise(function (resolve) {
      setTimeout(function () {
        Promise.resolve(f()).then(function (value) {
          resolve({
            value: value,
            seed: value,
            done: done
          });
        });
      }, interval);
    });
  }, false).filter((0, _equals2.default)(true));
};

exports.default = waitUntil;